/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class MinistrySafeService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get offer details for MinistrySafe.
     * @returns any OK
     * @throws ApiError
     */
    public getMinistrySafeOffer(): CancelablePromise<{
        data: {
            /**
             * The monthly fee of the integration.
             */
            monthlyFee?: number;
            /**
             * The setup fee of the integration.
             */
            setupFee?: number | null;
            /**
             * Whether or not the setup fee is waived.
             */
            setupFeeWaived?: boolean;
            /**
             * The currency code of the integration.
             */
            currencyCode?: string;
        };
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ministry-safe/offer',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Apply the MinistrySafe offer to the current subscription.
     * @returns void
     * @throws ApiError
     */
    public addMinistrySafeOffer(): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/ministry-safe/offer',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Simplified endpoint for setting up MinistrySafe in one call.
     * One-step setup endpoint for MinistrySafe integration (temporary solution for Pendo)
     * @returns any MinistrySafe successfully set up
     * @throws ApiError
     */
    public setupMinistrySafe(): CancelablePromise<{
        data: {
            /**
             * Status of the operation
             */
            status?: string;
            /**
             * A human-readable message about the operation
             */
            message?: string;
            /**
             * Whether MinistrySafe was already enabled
             */
            already_enabled?: boolean;
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/ministry-safe/offer/setup',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                500: `Error setting up MinistrySafe`,
            },
        });
    }

}
